// src/pages/Home/sections/featuers/components/FeaturesOne.js

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

// i18n
import { useTranslation } from "react-i18next";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function FeaturesOne() {
  const { t, i18n } = useTranslation();

  // 简单判断当前是否中文，用来决定图标颜色之类的小细节（可选）
  const isZh = i18n.language && i18n.language.toLowerCase().startsWith("zh");

  const features = [
    {
      key: "f1",
      icon: "play_circle",
      color: "info",
      title: t("features.items.1.title"),
      desc: t("features.items.1.desc"),
    },
    {
      key: "f2",
      icon: "public",
      color: "info",
      title: t("features.items.2.title"),
      desc: t("features.items.2.desc"),
    },
    {
      key: "f3",
      icon: "apps",
      color: "info",
      title: t("features.items.3.title"),
      desc: t("features.items.3.desc"),
    },
    {
      key: "f4",
      icon: "alt_route",
      color: "info",
      title: t("features.items.4.title"),
      desc: t("features.items.4.desc"),
    },
    {
      key: "f5",
      icon: "support_agent",
      color: "info",
      title: t("features.items.5.title"),
      desc: t("features.items.5.desc"),
    },
    {
      key: "f6",
      icon: "dns",
      color: "info",
      title: t("features.items.6.title"),
      desc: t("features.items.6.desc"),
    },
  ];

  return (
    <MKBox component="section" py={{ xs: 0, md: 20 }}>
      <Container>
        <Grid container spacing={4} justifyContent="center">
          {/* 顶部标题区域 */}
          <Grid item xs={12} textAlign="center">
            <MKTypography variant="h3" my={1}>
              {t("features.title")}
            </MKTypography>
            <MKTypography variant="body2" color="text" mb={2}>
              {t("features.subtitle")}
            </MKTypography>
          </Grid>

          {/* 六个 feature 项目：3×2 / 2×3 / 1×6 */}
          {features.map((item) => (
            <Grid item xs={12} sm={6} lg={4} key={item.key} display="flex" justifyContent="center">
              <MKBox display="flex" alignItems="center" p={2} width="100%" maxWidth="360px">
                <MKBox
                  width="3rem"
                  height="3rem"
                  variant="gradient"
                  bgColor={item.color}
                  color="white"
                  coloredShadow={item.color}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  borderRadius="xl"
                  sx={{ flexShrink: 0 }}
                >
                  <Icon baseClassName="material-icons-round" fontSize="small">
                    {item.icon}
                  </Icon>
                </MKBox>

                <MKBox pl={2}>
                  <MKTypography variant="button" color="text" fontWeight={isZh ? "bold" : "medium"}>
                    {item.title}
                  </MKTypography>
                  <MKTypography variant="body2" color="text" sx={{ fontSize: "0.85rem" }}>
                    {item.desc}
                  </MKTypography>
                </MKBox>
              </MKBox>
            </Grid>
          ))}
        </Grid>
      </Container>
    </MKBox>
  );
}

export default FeaturesOne;
